var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.191 0H4.81C1.77 0 0 1.78 0 4.83v10.33C0 18.26 1.77 20 4.81 20h8.381C16.28 20 18 18.26 18 15.16V4.83C18 1.78 16.28 0 13.191 0z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08 4.65v.01a.78.78 0 000 1.56h2.989c.431 0 .781-.35.781-.791a.781.781 0 00-.781-.779H5.08zm7.84 6.09H5.08a.78.78 0 010-1.561h7.84a.781.781 0 010 1.561zm0 4.57H5.08c-.3.04-.59-.11-.75-.36a.795.795 0 01.75-1.21h7.84c.399.04.7.38.7.79 0 .399-.301.74-.7.78z",
    fill: "#ED1B2E"
  })));
}

export default SvgDocument;